import { css } from 'linaria';
import { strictBreakpoints } from '../../../media';

export const сreditStyles = css`
	display: flex;
	min-height: 270px;
	overflow: hidden;
	border: 1px solid #e3e1d8;
	border-radius: 8px;
	${strictBreakpoints.onlyTablet} {
		flex-direction: column;
	}
	${strictBreakpoints.onlyMobile} {
		display: block;
	}

	.left {
		min-width: 474px;

		&__typography {
			font-weight: 700 !important;
			font-size: 32px !important;
			font-family: Roboto, Arial, sans-serif !important;
			font-style: normal !important;
			line-height: 40px !important;
			letter-spacing: 0.382px !important;
			color: var(--secondary-black, #000) !important;
			${strictBreakpoints.onlyDesktop} {
				font-size: 22px !important;
			}
			${strictBreakpoints.onlyTablet} {
				font-size: 32px !important;
			}
			${strictBreakpoints.onlyMobile} {
				font-size: 22px !important;
			}
		}

		&__wrapper {
			height: 100%;
			padding: 38px 24px;
			background-color: #fdc300;
			background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/v1724663283/fudzi/elbrus/images/landings/rough-work/Кредит бг_xxl.png/Кредит бг_xxl.png');
			background-repeat: no-repeat;
			background-position: right bottom;
			border-right: 1px solid #e3e1d8;
			${strictBreakpoints.onlyDesktop} {
				background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/v1724684678/fudzi/elbrus/images/landings/rough-work/Кредит бг_l.png/Кредит бг_l.png');
			}
			${strictBreakpoints.onlyTablet} {
				display: flex;
				align-items: center;
				min-height: 112px;
				padding: 42px 24px 30px;
				background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/v1724685468/fudzi/elbrus/images/landings/rough-work/Кредит бг_m.png/Кредит бг_m.png');
			}
			${strictBreakpoints.onlyMobile} {
				display: flex;
				align-items: center;
				min-height: 104px;
				padding: 38px 16px 26px;
				background-image: none;
			}
		}
		${strictBreakpoints.onlyDesktop} {
			min-width: 292px;
		}
	}

	.right {
		display: flex;
		gap: 24px;
		padding: 32px;

		&__text-container {
			padding-top: 8px;

			.wait-text {
				padding-top: 12px;
			}

			.cta-btn {
				padding: 12px 24px;
				margin-top: 16px;
				background: #e3e1d8;
				border-radius: 4px;

				&:hover {
					color: #333 !important;
				}
			}
		}
		${strictBreakpoints.onlyMobile} {
			flex-direction: column;
			gap: 8px;
		}
	}
`;
